(function () {
  if (!document.body.classList.contains('template-product')) return;
  if (!window.MinimogEvents) return;

  let lockedScrollY = null;

  function restoreScroll() {
    if (lockedScrollY === null) return;
    window.scrollTo({ top: lockedScrollY, left: 0, behavior: 'instant' });
  }

  function scheduleRestore() {
    requestAnimationFrame(restoreScroll);
    [50, 150, 300, 450].forEach((delay) => {
      setTimeout(restoreScroll, delay);
    });
    setTimeout(() => {
      lockedScrollY = null;
    }, 500);
  }

  document.addEventListener(
    'click',
    (event) => {
      if (!event.target.closest('.m-product-collapsible [data-trigger]')) return;
      lockedScrollY = window.scrollY;
    },
    true
  );

  ['ON_COLLAPSIBLE_TAB_OPENED', 'ON_COLLAPSIBLE_TAB_CLOSED'].forEach((eventName) => {
    window.MinimogEvents.subscribe(eventName, (tab) => {
      if (!tab?.closest?.('.m-product-collapsible')) return;
      scheduleRestore();
    });
  });
})();
